module.exports = __webpack_public_path__ + "img/ic_pl.5e4dbcec.svg";